import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm md:text-base font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-[#153568] text-white shadow hover:bg-[#153568]/90 ",
        linearprimary:
          "bg-gradient-to-r from-[#4285F4]  to-[#153568] text-white shadow-sm hover:from-[#153568] hover:to-[#4285F4]",
        destructive:
          "bg-[#E9684D] text-white  shadow-sm hover:bg-destructive/90",
        outline:
          "border border-primary text-black hover:bg-primary font-semibold hover:text-white shadow-sm ",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        green: "bg-[#5FD568] text-primary rounded-md hover:bg-[#5FD568]/90",
        orange: "bg-[#F2994A] text-primary rounded-md border ",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
// background: linear - gradient(90deg, #4285F4 0 %, #153568 100 %);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
